import $ from 'jquery';

import balanceText from 'balance-text';

import { FireDetect, FireComponentRecord, FireLazyLoader, FireHelpers } from '@base';

const detect = new FireDetect();
const componentRecord = new FireComponentRecord();
const lazyLoader = new FireLazyLoader();

/**
 * @type function
 * @name onPageReady
 * @description
 *
 * Initialize scripts when page is ready
 *
 **/
const onPageReady = () => {
  detect.setHtmlClasses();
  detect.detectTrueViewHeight();
  lazyLoader.init();
  lazyLoader.observer.observe();
  componentRecord.registerAllComponents();

  if (detect.touch && (detect.platform === 'iPhone' || detect.platform === 'iPad')) {
    FireHelpers.iOSFixDoubleTap();
  }

  balanceText();

  // display page
  $('body').addClass('has-loaded');

  // global Drupal behaviors
  Drupal.behaviors.fireGlobal = {
    attach: (context, settings) => {
      if (FireHelpers.ignoreContext(context, ['.toolbar-menu', '.status-messages'])) return;
      componentRecord.registerAllComponents(true);
      lazyLoader.observer.observe();
    },
  };

  // check for hero as first section and update heading to h1, remove h1.sr-only
  if (
    $('main section:first-of-type').hasClass('hero-detail') ||
    (!$('body').hasClass('bux-page-type--home') && $('main section:first-of-type').hasClass('hero-carousel')) ||
    $('main section:first-of-type').hasClass('search')
  ) {
    $('main h1.sr-only').remove();
    if ($('main section:first-of-type').hasClass('hero-detail')) {
      const heading = document.querySelector('main section:first-of-type.hero-detail h2');
      heading.outerHTML = `<h1 class="${heading.getAttribute('class')}">${heading.innerHTML}</h1>`;
    }
    if ($('main section:first-of-type').hasClass('hero-carousel')) {
      const heading = document.querySelector('main section:first-of-type.hero-carousel h2');
      heading.outerHTML = `<h1 class="${heading.getAttribute('class')}">${heading.innerHTML}</h1>`;
    }
    if ($('main section:first-of-type').hasClass('search')) {
      const heading = document.querySelector('main section:first-of-type.search h2');
      heading.outerHTML = `<h1 class="${heading.getAttribute('class') ? heading.getAttribute('class') : ''} bux-h2">${heading.innerHTML}</h1>`;
    }
  }
};

// fire all scripts
$(document).ready(onPageReady);
